<template>
  <b-navbar id="bottom-navbar">
    <b-row class="justify-content-center text-center">
      <b-col cols="12" md="auto">
        <copyright-link/>
      </b-col>
      <b-col cols="12" md="auto">
        <site-support-link class="mr-3"/>
        <privacy-policy-link/>
      </b-col>
    </b-row>
  </b-navbar>
</template>

<script>
import CopyrightLink from '../links/CopyrightLink'
import PrivacyPolicyLink from '../links/PrivacyPolicyLink'
import SiteSupportLink from '../links/SiteSupportLink'

export default {
  components: {
    CopyrightLink,
    PrivacyPolicyLink,
    SiteSupportLink
  }
}
</script>
